import React from "react";
import PropTypes from "prop-types";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import Header from "../component/Header";
import BottomNav from "../component/BottomNav";
import LendBook from "../component/LendBook";

import "../scss/library.scss";


function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`tabpanel-${index}`}
			aria-labelledby={`tab-${index}`}
			{...other}
		>
			{children}
		</div>
    );
};

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired
};

function a11yProps(index) {
	return {
		id: `tab-${index}`,
		"aria-controls": `tabpanel-${index}`
	};
}

export default function SimpleTabs() {
	const [value, setValue] = React.useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
    };

	return (
		<React.Fragment>
			<Header />
			<br />
			<div class="subtitle">
                <Tabs value={value} onChange={handleChange} aria-label="tabs" variant="fullWidth">
					<Tab label="나의 활동" {...a11yProps(0)} />
					<Tab label="관심 도서" {...a11yProps(1)} />
				</Tabs>
				</div>
			
			<TabPanel value={value} index={0}>
				<LendBook marktype="2" />
			</TabPanel>
			<TabPanel value={value} index={1}>
				<LendBook marktype="3" />
			</TabPanel>

			<BottomNav />
		</React.Fragment>
	);
}
